import React from 'react';
import { Grid } from '@material-ui/core';
import { useStyle } from './PrequalStyle';
import EirPrequalUnderMaintenanceForm from './EirPrequalUnderMaintenanceForm';
import EirPrequalInputTitle from './EirPrequalInputTitle';
import EirPrequalInputEircode from './EirPrequalInputEircode';
import { useLocalStorage} from './EirPrequalPersistance';
import EirPrequalDetailsContainer from './EirPrequalDetailsContainer';


export default function EirPrequalInputContainer(props) {
  const classes = useStyle();
   const {getLocalStorage} = useLocalStorage();
  let defaultProps = {
    backgroundImage: props.backgroundImage.path,
    prequalBannerCurveDesktop: props.prequalBannerCurveDesktop.path,
    foregroundImageDesktop: props.bannerImageDesktop.path,
    foregroundImageMobile: props.bannerImageMobile.path,
    prequalBannerCurveMobile: props.prequalBannerCurveMobile.path,
  };
  return (
    (getLocalStorage('ACQ_PREQUAL_RESULT')) ? <EirPrequalDetailsContainer 
    resources={props}
/>
  :
    <div className={classes.PrequalFormContainer}>
      <div
        className={classes.PrequalBackGround}
        style={{
          background: `url(${defaultProps.backgroundImage}) center top/100% 100% no-repeat`,
        }}
      >
        <div className={classes.PrequalContainer}>
          <Grid className={classes.PrequalLeftPart}>
            <EirPrequalInputTitle title={props.title} text={props.text} fontColor={props.textFontColor} />

            {props.underMaintenance ? (
              <EirPrequalUnderMaintenanceForm
                underMaintenanceText={props.underMaintenanceText}
                underMaintenanceCTAText={props.underMaintenanceCTAText}
                underMaintenanceRedirectURL={props.underMaintenanceRedirectURL}
              />
            ) : (
              <EirPrequalInputEircode
              props={props} />
            )}
          </Grid>

          <Grid className={classes.PrequalRightPart}>
            <picture>
              <source
                media='(max-width: 1019px)'
                srcSet={defaultProps.foregroundImageMobile.path}
              />

              <img
                className={classes.PrequalBanner}
                src={defaultProps.foregroundImageDesktop}
                onLoad={(event) => {
                  event.target.style.display = 'inline-block';
                }}
              />
            </picture>
          </Grid>
        </div>
      </div>
      <picture>
        <source
          media='(max-width: 1019px)'
          srcSet={defaultProps.prequalBannerCurveMobile.path}
        />
        <img
          className={classes.PrequalBannerCurve}
          src={defaultProps.prequalBannerCurveDesktop}
        />
      </picture>
    </div>
                       
  );
              
}
